module.exports = __webpack_public_path__ + "media/images/squadBet__playerPlaceholder-ea190d1a202f3d888d9c68f2312ee5d7.png";